import { CreatePasswordSchema, CreatePasswordSchemaType } from "./LoginSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { resetPasswordApi } from "../../api/auth";
import { Dispatch, SetStateAction, useState } from "react";
import { useSnackbar } from "../../context/SnackbarContext";
import TextField from "../../Components/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import passwordIcon from "../../assets/login_password.svg";
import { CircularProgress, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

type Props = {
  setStep: Dispatch<SetStateAction<number>>;
};

const CreatePasswordForm = ({ setStep }: Props) => {
  const { register, handleSubmit, formState, watch } =
    useForm<CreatePasswordSchemaType>({
      mode: "onTouched",
      resolver: yupResolver(CreatePasswordSchema),
      defaultValues: { password: "" },
    });

  const passwordVal = watch("password");

  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const { showSnackbar } = useSnackbar();

  const createPassword = async (e: CreatePasswordSchemaType) => {
    setLoading(true);

    try {
      const response = await resetPasswordApi(e.password);

      if (response.data.data) {
        showSnackbar(response.data.responseInfo?.description, "success");
        setStep(3);
        setErrorMessage("");
      } else {
        setErrorMessage(response.data.responseInfo?.description);
      }
    } catch (error) {
      console.error("Error during login:", error);
    }
    setLoading(false);
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <form
      className="login-form textFieldWrapper"
      onSubmit={handleSubmit(createPassword)}
    >
      <div className="input-container">
        <TextField
          className="textFieldMargins"
          label=""
          fullWidth
          placeholder="Password"
          type={showPassword ? "text" : "password"}
          autoComplete="new-password"
          {...register("password")}
          error={!!formState.errors.password || !!errorMessage}
          helperText={formState.errors.password?.message || errorMessage}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img
                  onClick={handleTogglePasswordVisibility}
                  src={passwordIcon}
                  alt="password_icon"
                />
              </InputAdornment>
            ),
            endAdornment: (
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleTogglePasswordVisibility}
                edge="end"
                style={{ marginRight: "4px" }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <div className="submit-container">
          {loading ? (
            <button className="submit-button" type="submit">
              <CircularProgress size={20} color="inherit" />
            </button>
          ) : (
            <button
              className="submit-button"
              type="submit"
              disabled={passwordVal.length < 8}
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </form>
  );
};

export default CreatePasswordForm;
